import React, { useState } from "react";
import style from "./CreatorInvite.module.css";
import InputText from "../../component/inputText/InputText";
import { CreatorApi } from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";
import Button from "../../component/button/Button";

const CreatorInvite = ({ isOpen, onClose, onInviteSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    channel_name: "",
  });

  const [loading, setLoading] = useState(false);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendInvite = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await CreatorApi(formData);
      showToast(response.data.message, "success");
      setLoading(false);

      if (onInviteSuccess) {
        onInviteSuccess(); 
      }

      setTimeout(() => {
        setFormData({
          name: "",
          email: "",
          channel_name: "",
        });
        onClose();
      }, 500);
    } catch (error) {
      setLoading(false);
      const response = error?.response?.data;
      if (response?.errors) {
        const fieldErrors = Object.values(response.errors).flat();
        if (fieldErrors.length > 0) {
          showToast(fieldErrors[0], "error");
        } else if (response.message) {
          showToast(response.message, "error");
        }
      } else if (response?.message) {
        showToast(response.message, "error");
      }
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className={style.overlay} onClick={handleOverlayClick}>
        <div className={style.modal}>
          <div className={style.headingText}>Creator Invite</div>
          <form onSubmit={handleSendInvite}>
            <div className={style.inputBox}>
              <InputText
                name="name"
                value={formData.name}
                placeholder="Full Name"
                type="text"
                variant="modal"
                className={style.inputText}
                onChange={handleChange}
              />
              <InputText
                name="email"
                value={formData.email}
                placeholder="Email Address"
                variant="modal"
                type="text"
                className={style.inputText}
                onChange={handleChange}
              />
              <InputText
                name="channel_name"
                value={formData.channel_name}
                placeholder="Channel Name"
                type="text"
                variant="modal"
                className={style.inputText}
                onChange={handleChange}
              />
            </div>

            <div className={style.sendBtn}>
              <Button
                className={style.inviteText}
                type="submit"
                loading={loading}
                style={{ background: loading ? "none" : "#b87333" }}
              >
                Send Invite
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreatorInvite;
